var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 17.225C18.3417 17.225 18.1834 17.1667 18.0584 17.0417L12.625 11.6084C11.7417 10.725 11.7417 9.27502 12.625 8.39168L18.0584 2.95835C18.3 2.71668 18.7 2.71668 18.9417 2.95835C19.1834 3.20002 19.1834 3.60002 18.9417 3.84168L13.5084 9.27502C13.1084 9.67502 13.1084 10.325 13.5084 10.725L18.9417 16.1583C19.1834 16.4 19.1834 16.8 18.9417 17.0417C18.8167 17.1584 18.6584 17.225 18.5 17.225Z",
    fill: "#787486"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 17.225C12.3417 17.225 12.1834 17.1667 12.0584 17.0417L6.62502 11.6084C5.74169 10.725 5.74169 9.27502 6.62502 8.39168L12.0584 2.95835C12.3 2.71668 12.7 2.71668 12.9417 2.95835C13.1834 3.20002 13.1834 3.60002 12.9417 3.84168L7.50836 9.27502C7.10836 9.67502 7.10836 10.325 7.50836 10.725L12.9417 16.1583C13.1834 16.4 13.1834 16.8 12.9417 17.0417C12.8167 17.1584 12.6584 17.225 12.5 17.225Z",
    fill: "#787486"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/Hide.a9a243fa17e3dd16f0281484a2bb9aed.svg";
export { ForwardRef as ReactComponent };